import { bindDingandLiu, getDingUser, getUserNumbyUserId } from '@/api';
import store from '@/store/index';
import { get } from '@/utils/ajax.js';
import * as dd from 'dingtalk-jsapi';
import { Toast } from 'vant';
import { request, setAuthorization } from './request';

const EXPIRE_DURATION = 86400 * 1000; // 24小时
const APP_SECRET = '54f52318e1312f12ca4bc96342aac346'; // 世外
// const APP_ID = 'e70ae4c07023d304'; // 应用ID
const APP_ID = 'b7a812150321bac4'; // 应用ID

// 判断是否是钉钉环境
export function isDingTalkEnvironment() {
  return window && window.isDingtalk;
}

// 获取URL中的参数
function getHashParams() {
  const hash = window.location.hash;
  const params = {};
  const hashQueryString = hash.split('?')[1];

  if (hashQueryString) {
    const pairs = hashQueryString.split('&');
    for (const pair of pairs) {
      const [key, value] = pair.split('=');
      params[key] = decodeURIComponent(value);
    }
  }
  return params;
}

// 获取URL中的code
function getCode() {
  const urlParams = new URLSearchParams(window.location.href.split('?')[1]);
  const code = urlParams.get('code');
  return { code: code ? decodeURIComponent(code) : '' };
}
// 生成跳转URL
export function getAuthorizeUrlEnd() {
  const redirectUri = encodeURIComponent(`${VUE_FRONT_BASE_URL}`);
  return `http://its.shwfl.edu.cn/oauth/wfl_its/authorize?app_id=${APP_ID}&redirect_uri=${redirectUri}&response_type=code`;
}

// 获取用户信息
export async function getUser() {
  if (isDingTalkEnvironment()) {
    console.log('钉钉环境')
    // 钉钉环境
    try {
      const { code } = getCode();
      console.log('code', code,getAuthorizeUrlEnd())
      if (!code) {
        dd.navigateToPage({
          url: getAuthorizeUrlEnd(),
          success: () => {},
          fail: () => {},
          complete: () => {},
        });
        return;
      }
      // const tokenRes = await get(`/oauth/wfl_its/access_token?app_id=${APP_ID}&app_secret=${APP_SECRET}&code=${code}`);
      // const userRes = await get('/oauth/wfl_its/user_info', null, {
      //   headers: { Authorization: `Bearer ${tokenRes.data.access_token}` },
      // });
      const userInfo = await request(`/platform/shiWai/login?code=${code}`, 'post');
      if (userInfo.data.code === 1) {
        setAuthorization({
          token: userInfo.data.message,
          expireAt: new Date(Date.now() + EXPIRE_DURATION),
        });
        store.commit('setUserInfo', userInfo.data.data);
      } else {
        Toast.fail(userInfo.data.message);
      }
    } catch (error) {
      dd.navigateToPage({
        url: getAuthorizeUrlEnd(),
        success: () => {},
        fail: () => {},
        complete: () => {},
      });
      Toast.fail('系统异常，请重新进入',error);
      throw error;
    }
  } else {
    console.log('Web 环境')
    // Web 环境
    try {
      const { code } = getCode();
      console.log('code', code,!code)
      if (!code) {
        console.log('code', "跳转去取code")
        window.location.href = getAuthorizeUrlEnd();
        return;
      }
      // const tokenRes = await get(`/oauth/wfl_its/access_token?app_id=${APP_ID}&app_secret=${APP_SECRET}&code=${code}`);
      // const userRes = await get('/oauth/wfl_its/user_info', null, {
      //   headers: { Authorization: `Bearer ${tokenRes.data.access_token}` },
      // });

      const userInfo = await request(`/platform/shiWai/login?code=${code}`, 'post');

      if (userInfo.data.code === 1) {
        setAuthorization({
          token: userInfo.data.message,
          expireAt: new Date(Date.now() + EXPIRE_DURATION),
        });
        store.commit('setUserInfo', userInfo.data.data);
      } else {
        Toast.fail(userInfo.data.message);
      }
    } catch (error) {
      console.error('获取用户信息失败', error);
        window.location.href = getAuthorizeUrlEnd();
    }
  }
}

// 清除用户数据
export function clearUserData() {
  store.commit('setUserInfo', null);
}


// WEBPACK FOOTER //
// ./src/utils/getUser.js